
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-4 mb-6">
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-br from-rose-600/20 to-gray-700/20 rounded-full transform -rotate-1 group-hover:rotate-1 transition-transform duration-500"></div>
                <div className="relative rounded-full p-3 group-hover:scale-105 transition-transform duration-300">
                  <img 
                    src="https://static.readdy.ai/image/5d1a9eb3e1ef0df3b8285fbcdadbd077/c70d87acbff9e446518c19e27f0b0373.png" 
                    alt="FR Odontologia Logo" 
                    className="w-20 h-20 object-cover rounded-full"
                    style={{ 
                      objectPosition: 'center',
                      filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.2))'
                    }}
                  />
                </div>
              </div>
              <div>
                <span className="text-3xl font-bold text-white block" style={{ fontFamily: 'Inter, sans-serif' }}>
                  <span className="text-rose-400">FR</span> Odontologia
                </span>
              </div>
            </div>
          </div>

          {/* Contato da Clínica */}
          <div>
            <h3 className="text-2xl font-bold mb-8 text-gray-200 flex items-center gap-2">
              <i className="ri-phone-line text-xl text-rose-400"></i>
              Contato
            </h3>
            <div className="space-y-6">
              <div className="group cursor-pointer">
                <div className="flex items-center space-x-4 p-4 rounded-xl bg-gradient-to-r from-white/10 to-white/5 hover:from-white/15 hover:to-white/10 transition-all duration-300 border border-white/20 hover:border-rose-400/50 shadow-lg">
                  <div className="w-14 h-14 bg-rose-600 rounded-xl flex items-center justify-center group-hover:bg-rose-500 transition-colors duration-300 shadow-lg">
                    <i className="ri-phone-line text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-400 mb-1 font-medium">Telefone</p>
                    <p className="text-white font-bold text-lg">(11) 5199-2947</p>
                  </div>
                </div>
              </div>
              
              <a 
                href="https://wa.me/5511998961030" 
                target="_blank" 
                rel="noopener noreferrer"
                className="group cursor-pointer block"
              >
                <div className="flex items-center space-x-4 p-4 rounded-xl bg-gradient-to-r from-green-600/20 to-green-500/10 hover:from-green-600/30 hover:to-green-500/20 transition-all duration-300 border border-green-500/30 hover:border-green-400/60 shadow-lg">
                  <div className="w-14 h-14 bg-green-600 rounded-xl flex items-center justify-center group-hover:bg-green-500 transition-colors duration-300 shadow-lg">
                    <i className="ri-whatsapp-line text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-400 mb-1 font-medium">WhatsApp</p>
                    <p className="text-white font-bold text-lg">(11) 99896-1030</p>
                  </div>
                </div>
              </a>

              <a 
                href="https://www.instagram.com/_frodontologia/?theme=dark" 
                target="_blank" 
                rel="noopener noreferrer"
                className="group cursor-pointer block"
              >
                <div className="flex items-center space-x-4 p-4 rounded-xl bg-gradient-to-r from-rose-600/20 to-rose-500/10 hover:from-rose-600/30 hover:to-rose-500/20 transition-all duration-300 border border-rose-500/30 hover:border-rose-400/60 shadow-lg">
                  <div className="w-14 h-14 bg-rose-600 rounded-xl flex items-center justify-center group-hover:scale-105 transition-colors duration-300 shadow-lg">
                    <i className="ri-instagram-line text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-400 mb-1 font-medium">Instagram</p>
                    <p className="text-white font-bold text-lg">@_frodontologia</p>
                  </div>
                </div>
              </a>
            </div>
          </div>

          {/* Localização da Clínica */}
          <div>
            <h3 className="text-2xl font-bold mb-8 text-gray-200 flex items-center gap-2">
              <i className="ri-map-pin-line text-xl text-rose-400"></i>
              Localização
            </h3>
            <div className="group cursor-pointer">
              <div className="p-6 rounded-xl bg-gradient-to-br from-white/10 to-white/5 hover:from-white/15 hover:to-white/10 transition-all duration-300 border border-white/20 hover:border-rose-400/50 shadow-lg">
                <div className="flex items-start space-x-4 mb-6">
                  <div className="w-14 h-14 bg-rose-600 rounded-xl flex items-center justify-center group-hover:bg-rose-500 transition-colors duration-300 flex-shrink-0 shadow-lg">
                    <i className="ri-map-pin-line text-white text-xl"></i>
                  </div>
                  <div className="flex-1">
                    <p className="text-white font-bold leading-relaxed text-base mb-1">
                      Av. Sagitário, 138
                    </p>
                    <p className="text-gray-300 text-sm leading-relaxed font-medium">
                      Alpha Square Mall - Sala 1307<br />
                      Torre London - Alphaville<br />
                      Barueri/SP
                    </p>
                  </div>
                </div>
                <div className="bg-white/5 rounded-lg p-4 border border-white/10">
                  <div className="flex items-center gap-2 mb-3">
                    <i className="ri-time-line text-rose-300 text-lg"></i>
                    <span className="text-gray-300 font-semibold text-sm">Horário de Atendimento</span>
                  </div>
                  <div className="text-gray-300 font-medium text-sm">
                    Segunda a Sexta: 9h às 18h
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Rodapé da Clínica */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm font-medium">
              © 2025 FR Odontologia. Todos os direitos reservados.
            </div>
            <div className="flex items-center space-x-6">
              <a 
                href="https://www.doctoralia.com.br/flavia-cristina-rodrigues/dentista/sao-paulo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-rose-300 transition-colors duration-300 text-sm font-medium cursor-pointer"
              >
                Doctoralia
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-rose-300 transition-colors duration-300 text-sm font-medium cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
